import { Form } from '@dnb/eufemia/extensions/forms';
import SectionContainerContext from '@dnb/eufemia/extensions/forms/Form/Section/containers/SectionContainerContext';
import { useContext, useEffect } from 'react';

import { SwitchContainerModeRef } from '@/types/SwitchContainerModeTypes';

type Props = {
  disabled?: boolean;
  switchContainerModeRef: SwitchContainerModeRef;
  onClick?: () => void;
};

const FormSubmitButton = ({ disabled, switchContainerModeRef, onClick }: Props) => {
  const { switchContainerMode } = useContext(SectionContainerContext);
  useEffect(() => {
    if (switchContainerMode) {
      switchContainerModeRef.current = switchContainerMode;
    }
  }, [switchContainerMode, switchContainerModeRef]);

  return <Form.SubmitButton disabled={disabled} icon="save" icon_position="left" onClick={onClick} text="Save" />;
};

export default FormSubmitButton;
